const STORAGE_KEY = 'imobdesk_entry_app'

export type ImobdeskEntryApp =
  | 'login'
  | 'app'
  | 'suporte'
  | 'admindesk'

/**
 * Persiste a origem do fluxo (para o header `X-Imobdesk-Entry-App` nas chamadas à API).
 */
export function setImobdeskEntryApp(value: ImobdeskEntryApp | string | null | undefined) {
  if (typeof window === 'undefined' || value == null || String(value).trim() === '') {
    return
  }
  const v = String(value).trim().toLowerCase()
  if (
    v === 'suporte' ||
    v === 'admindesk' ||
    v === 'app' ||
    v === 'login' ||
    v === 'workspace'
  ) {
    window.sessionStorage.setItem(STORAGE_KEY, v === 'workspace' ? 'app' : v)
  }
}

/**
 * Lê o valor enviado em `X-Imobdesk-Entry-App` (API Nest).
 */
export function getImobdeskEntryAppHeader(): string {
  if (typeof window === 'undefined') return 'login'
  const raw = window.sessionStorage.getItem(STORAGE_KEY)?.trim().toLowerCase()
  if (
    raw === 'suporte' ||
    raw === 'admindesk' ||
    raw === 'app' ||
    raw === 'login'
  )
    return raw
  return 'login'
}

type LoginSearchLike = {
  return_app?: 'suporte' | 'admindesk'
  next?: string
}

/**
 * Deduz a origem a partir da URL de login (`return_app`, `next` → app principal).
 * Sem indícios na URL, volta para `login` (evita valor antigo no sessionStorage).
 */
export function syncImobdeskEntryAppFromSearch(search: LoginSearchLike) {
  if (search.return_app === 'suporte') {
    setImobdeskEntryApp('suporte')
    return
  }
  if (search.return_app === 'admindesk') {
    setImobdeskEntryApp('admindesk')
    return
  }
  const n = search.next?.trim()
  if (n && /^\/(workspace|dashboard)(\/|$)/.test(n)) {
    setImobdeskEntryApp('app')
    return
  }
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(STORAGE_KEY, 'login')
  }
}
